import type { AppRole } from './types';

/**
 * UI-level permission hints. They only decide what to render; every rule is
 * enforced again by RLS / Edge Functions on the server.
 */
export const ADMIN_ROLES: readonly AppRole[] = ['SUPERADMIN', 'ADMIN'];
export const SUPERADMIN_ROLES: readonly AppRole[] = ['SUPERADMIN'];

export function hasRole(
  role: AppRole | undefined,
  allowed: readonly AppRole[] | undefined,
): boolean {
  if (!allowed) return true;
  return role !== undefined && allowed.includes(role);
}

export const can = {
  manageCatalog: (role: AppRole | undefined) => hasRole(role, ADMIN_ROLES),
  manageBilling: (role: AppRole | undefined) => hasRole(role, ADMIN_ROLES),
  manageBoards: (role: AppRole | undefined) => hasRole(role, ADMIN_ROLES),
  manageUsers: (role: AppRole | undefined) => hasRole(role, SUPERADMIN_ROLES),
  manageIntegrations: (role: AppRole | undefined) => hasRole(role, SUPERADMIN_ROLES),
  /** Create/deactivate mailboxes and grant access. Reading mail still needs membership. */
  manageMailboxes: (role: AppRole | undefined) => hasRole(role, ADMIN_ROLES),
};
